import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const LoadingScreen = ({ onLoadingComplete, title = 'VELOURA' }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      const simulateAPI = () => {
        return new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      };

      const progressInterval = setInterval(() => {
        setLoadingProgress((prev) => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + Math.random() * 15;
        });
      }, 50);

      await simulateAPI();

      clearInterval(progressInterval);
      setLoadingProgress(100);

      setTimeout(() => {
        const screen = document.querySelector('.loading-screen');
        if (screen) {
          screen.setAttribute('data-exiting', 'true');
        }
        setTimeout(() => {
          setIsLoading(false);
          if (onLoadingComplete) {
            onLoadingComplete();
          }
        }, 400);
      }, 500);
    };

    loadData();
  }, [onLoadingComplete]);

  if (!isLoading) return null;

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2,
        ease: "easeOut"
      }}
      className="loading-screen"
      style={{ opacity: 1 }}
    >
      <div className="loading-content">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.1 }}
          transition={{ duration: 0.6 }}
          className="loading-logo"
        >
          <motion.h1
            layoutId="veloura-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="loading-title"
          >
            {title}
          </motion.h1>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ duration: 0.3 }}
          className="loading-progress-container"
        >
          <div className="loading-progress-bar">
            <motion.div
              className="loading-progress-fill"
              initial={{ width: 0 }}
              animate={{ width: `${loadingProgress}%` }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            />
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            className="loading-text"
          >
            {loadingProgress < 100 ? 'Loading...' : 'Ready'}
          </motion.p>
        </motion.div>
      </div>

    </motion.div>

  );
};

export default LoadingScreen;

